export class GEMP {
  nombre!: string;
  idGEMP!: string;
  logoBase64!: string;
  abreviatura!: string;

  constructor(grupoEmpresarial: GEMP) {
    {
      this.nombre = grupoEmpresarial.nombre || '';
      this.idGEMP = grupoEmpresarial.idGEMP || '';
      this.logoBase64 = grupoEmpresarial.logoBase64 || '';
      this.abreviatura = grupoEmpresarial.abreviatura || '';
    }
  }
}
